import { FieldWrapper } from '@dixa/lib-shared-habla';
import { PureComponent } from 'react';
import type { WrappedFieldProps as WrappedFieldPropsT } from 'redux-form';

import { CategorizedMultiSelectCategory } from './categorizedMultiSelectCategory';
import styles from './fieldCategorizedMultiSelect.module.scss';

export type FieldCategorizedMultiSelectCategoryValuesItemT = {
  name: string;
  value: string;
  icon: string;
};

export type FieldCategorizedMultiSelectCategoryValuesT = {
  categoryName: string;
  disabled: boolean;
  items: Array<FieldCategorizedMultiSelectCategoryValuesItemT>;
};

export type FieldCategorizedMultiSelectPropsT = {
  categoryOptions: FieldCategorizedMultiSelectCategoryValuesT[];
  readOnly?: boolean;
  label?: string;
  required?: boolean;
} & WrappedFieldPropsT;

export class FieldCategorizedMultiSelect extends PureComponent<FieldCategorizedMultiSelectPropsT> {
  hasError() {
    const { meta } = this.props;
    if (meta.error) {
      return meta.touched === undefined || meta.touched === true;
    }
    return false;
  }

  getErrorMessage() {
    if (this.hasError()) {
      const { meta } = this.props;
      return meta.error as string;
    }
    return undefined;
  }

  render() {
    const {
      label,
      required,
      categoryOptions,
      input,
      readOnly = false,
      ...otherProps
    } = this.props;

    return (
      <FieldWrapper
        label={label}
        required={required}
        labelFor={input.name}
        meta={{
          error: this.getErrorMessage(),
        }}
        className={styles.root}
      >
        <div className={styles.container}>
          {categoryOptions.map(
            (cat: FieldCategorizedMultiSelectCategoryValuesT) => {
              return (
                <CategorizedMultiSelectCategory
                  key={cat.categoryName}
                  readOnly={readOnly}
                  input={input}
                  {...otherProps}
                  category={cat}
                />
              );
            },
          )}
        </div>
      </FieldWrapper>
    );
  }
}
